<template>
    <div class="refund_warp">
        <div class="refund_title">申请退款</div>
        <div class="refund_list">
            <div class="refund_item_left">店铺号</div>
            <input class="refund_item_right not_border hui_color" readonly :value="store_name" />
        </div>
        <div class="refund_list">
            <div class="refund_item_left">日期</div>
            <input class="refund_item_right" readonly v-model="dateVal" @click="selectTime"/>
        </div>
        <div class="refund_list">
            <div class="refund_item_left">该日账户余额</div>
            <input class="refund_item_right" readonly placeholder="账号余额" v-model="money" />
            <button class="refund_query" @click="queryBtnFun">查询</button>
        </div>
        <div class="refund_list">
            <div class="refund_item_left">退款银行</div>
            <div class="refund_item_right" @click="selectBank">{{bankVal}}</div>
        </div>
        <div class="refund_list">
            <div class="refund_item_left">户名</div>
            <input class="refund_item_right" placeholder="请填写户名" v-model="name" />
        </div>
        <div class="refund_list">
            <div class="refund_item_left">账号</div>
            <input class="refund_item_right" placeholder="请填写账号" v-model="account" />
        </div>
        <button class="refund_confirm" @click="confirmButton">确认</button>
        <Time 
            ref="timeShowBoxFun"
            @timeConfirm="timeConfirm"
        />
        <Bank 
         ref="bankShowBoxFun"
         :columns="columns"
         @bankConfirm="bankConfirm"
        />
    </div>
</template>

<script>
import Time from '@/components/time.vue'
import Bank from '@/components/bank.vue'
import Vue from 'vue';
import { Toast } from 'vant';
import autho from '../autho/autho.js'

Vue.use(Toast);
var that;
export default {
    data(){
        return {
            dateVal:'请选择日期',
            columns:['中国银行','中国工商银行','中国建设银行','中国农业银行','中国招商银行','中国邮政储蓄银行'],
            bankVal:'请选择银行',
            name:'',
            account:'',
            money:'',
            accountChangeId:'',
            store_name:'',
            accountCode:''
        }
    },
    mounted(){
        that = this;
        that.store_name = that.$route.query.address;
        that.accountCode = that.$route.query.accountCode;
    },
    components:{
        Time,
        Bank
    },
    methods:{
        selectTime(){
            that.$refs.timeShowBoxFun.showPopup(true)
        },
        // 时间组件回调 时间确认
        timeConfirm(val){
            that.dateVal = that.handleTimeFun(val);
        },
        handleTimeFun(timer){
            var date = new Date(timer);
            var YY = date.getFullYear() + '-';
            var MM = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var DD = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
            return YY+MM+DD
        },
        // 选择银行
        selectBank(){
            that.$refs.bankShowBoxFun.showPopup(true)
        },
        // 银行组件回调 银行确认
        bankConfirm(val){
            that.bankVal = val;
        },
        // 表单确认
        async confirmButton(){
            if(that.dateVal == '请选择日期'){
                Toast({message:'请选择日期',forbidClick:true});
                return false;
            }
            if(that.bankVal == '请选择银行'){
                Toast({message:'请选择银行',forbidClick:true});
                return false;
            }
            if(!that.name){
                Toast({message:'请填写户名',forbidClick:true});
                return false;
            }
            if(!that.account){
                Toast({message:'请填写账号',forbidClick:true});
                return false;
            }
            let data_msg = {
                accountChangeId:that.accountChangeId,
                accountCode:that.accountCode,
                accountDate:that.dateVal,
                bankAccountName:that.name,
                bankName:that.bankVal,
                bankNum:that.account,
                money:that.money
            }
            const res = await autho.request('token','post','/gzhWxApiController/refund',data_msg)
            autho.resetDataFun(res,function(){
                Toast({message:'提交成功',forbidClick:true,onClose(){
                    that.$router.push({path:'/'})
                }});
            })
        },
        // 查询改日账户余额
        async queryBtnFun(){
            if(that.dateVal == '请选择日期'){
                Toast({message:'请选择日期',forbidClick:true});
                return false;
            }
            const res = await autho.request('token','post','/gzhWxApiController/selectAccountMoney',{accountCode:that.accountCode,accountDate:that.dateVal})
            autho.resetDataFun(res,function(){
                let _data = res.data.data;
                that.money = _data.money;
                that.accountChangeId = _data.accountChangeId;
            })
        }
    }
}
</script>

<style scoped>
.refund_warp {
    padding: 0.1rem 0.3rem;
}
.refund_title {
    font-size: 0.2rem;
    font-weight: bold;
    text-align: center;
    margin: 0.3rem 0;
}
.refund_list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.2rem;
}
.refund_item_left {
    width: 1rem;
    margin-right: 0.1rem;
    text-align: justify;
    text-align-last:justify;
    font-size: 0.16rem;
    color: #333;
    line-height: 0.3rem;
}
.refund_item_right {
    flex: 1;
    border:1px solid #ccc;
    height: 0.3rem;
    line-height: 0.3rem;
    padding: 0 0.05rem;
    outline: none;
    background-color: rgb(0 0 0/0);
    font-size: 0.16rem;
    width: 0.5rem;
}
.not_border {
    border:none;
}
.hui_color {
    color: #999;
}
.refund_confirm {
    width: 80%;
    height: 0.4rem;
    border: none;
    outline: none;
    border-radius: 0.1rem;
    color: #fff;
    font-size: 0.16rem;
    background-color: #4c97fc;
    margin: 0.3rem auto;
    display: block;
}
.refund_query {
    width: 0.5rem;
    height: 0.3rem;
    outline: none;
    border: none;
    background-color: #4c97fc;
    border-radius: 0.05rem;
    color: #fff;
    margin-left: 0.1rem;
}
</style>